import { Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { useTheme } from '~/components/ui/hooks/use-theme'
import useTranslations from '~/helpers/store/locale/translation'

/** Langue et thème, réglables avant connexion : en haut des écrans d'authentification. */
function AuthPreferences() {
  const { t, i18n } = useTranslation()
  const { theme, setTheme } = useTheme()
  const { changeLanguage } = useTranslations()
  const isFr = i18n.language.startsWith('fr')

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        // Par le store : le choix est retenu, et l'emporte sur la langue de l'organisation (#146).
        onClick={() => changeLanguage(isFr ? 'en' : 'fr')}
        className="rounded-full font-medium"
        // Le nom commence par ce qui est affiché (« FR »), puis dit ce que fait le bouton (RGAA 11.9).
        aria-label={t('login.language.toggle', { current: isFr ? 'FR' : 'EN', target: isFr ? 'English' : 'Français' })}
      >
        {isFr ? 'FR' : 'EN'}
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
        className="rounded-full"
        aria-label={theme === 'light' ? t('theme.dark') : t('theme.light')}
      >
        {theme === 'light' ? <Moon className="size-5" /> : <Sun className="size-5" />}
      </Button>
    </div>
  )
}

export default AuthPreferences
